/* ══════════════════════════════════════════════════════════════════
   `theme-color` folgt der gezeigten Darstellung (07.10.2026, Signal-Umbau
   Paket 2; app-design-muster, grundlagen/web-app-huelle.md § 2/§ 3).

   Die zwei Metas in `index.html` gelten mit `media` für das Bild des
   Systems. Wer in der Anwendung „Dunkel" wählt, während das System hell
   ist, bekam darum einen hellen Safari-Rahmen über einem dunklen Kopf.
   Hier wird die Farbe des Rahmens (`--rahmenfarbe`, `stile/schale.css`)
   zur Laufzeit in **beide** Metas geschrieben — beim Start, beim Wechsel
   der Darstellung, des Systembilds, des Geräts und wenn die Anmeldung
   kommt oder geht (sie hat oben eine eigene Fläche).
   ══════════════════════════════════════════════════════════════════ */

function setzen(): void {
  const metas = document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]');
  if (!metas.length || !document.body) return;
  const roh = getComputedStyle(document.documentElement).getPropertyValue("--rahmenfarbe").trim();
  // `var(--nav)` ist hier schon aufgelöst; fehlt die Variable, gilt der Grund des Körpers.
  const farbe = roh || getComputedStyle(document.body).backgroundColor;
  metas.forEach((m) => { m.content = farbe; });
}

let geplant = false;
function bald(): void {
  if (geplant) return;
  geplant = true;
  requestAnimationFrame(() => { geplant = false; setzen(); });
}

/** Einmal beim Start (`main.tsx`). */
export function themaFarbeFolgen(): void {
  if (typeof document === "undefined") return;
  bald();
  new MutationObserver(bald).observe(document.documentElement, {
    attributes: true, attributeFilter: ["data-theme", "data-geraet"],
  });
  matchMedia("(prefers-color-scheme: dark)").addEventListener("change", bald);
  /* Anmeldung ↔ Anwendung: Die Anmeldung am Telefon hat oben eine eigene
     Fläche (`.anm-t`). Geprüft wird nur, ob sie kam oder ging — nicht bei
     jedem Zeichnen neu gerechnet. */
  const wurzel = document.getElementById("wurzel");
  let anmeldung = false;
  if (wurzel) {
    new MutationObserver(() => {
      const jetzt = !!wurzel.querySelector(".anm-t, .anmeldung");
      if (jetzt !== anmeldung) { anmeldung = jetzt; bald(); }
    }).observe(wurzel, { childList: true, subtree: true });
  }
}
